import { Flex, Text } from '@chakra-ui/react'

export function ListProduct({ product, handleSelectProduct }) {
  return (
    <Flex
      key={product.url_seo}
      p="1"
      onClick={() => handleSelectProduct(product)}
      _hover={{ bg: 'gray.100' }}
      cursor="pointer"
      px={1}
    >
      <Text textTransform="capitalize">{product.nome}</Text>
    </Flex>
  )
}
